var React = require('react');

function Cube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M35.3981 30.8278V11.1227L18.2973 1.29468L1.24573 11.1227V30.8278L18.2973 40.705L35.3981 30.8278Z","stroke":"#D22128","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M18.4447 21.0491L31.4177 13.4324","stroke":"#D22128","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M18.4447 21.0491L31.4177 13.4324","stroke":"#D22128","strokeMiterlimit":"10","key":2}),React.createElement("path",{"d":"M18.4447 21.0491L5.47168 13.4324","stroke":"#D22128","strokeMiterlimit":"10","key":3}),React.createElement("path",{"d":"M18.4447 34.3169V21.0491","stroke":"#D22128","strokeMiterlimit":"10","key":4})]);
}

Cube.defaultProps = {"width":"36","height":"42","viewBox":"0 0 36 42","fill":"none"};

module.exports = Cube;

Cube.default = Cube;
